import template from 'text!./ContactRoleLaborClient.html';
import controller from './ContactRoleLaborClientCtrl';

export default {
    template: template,
    controller: controller,
    bindings: {
        roleType: '@',
        roleModel: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleLaborClient/index.js
// module id = 1647
// module chunks = 0